import { observer } from "mobx-react-lite";
import { useWindowSize } from "../effects/useWindowSize";
import BackIconBig from "../icons/BackIconBig";
import { store } from "../stores/Store";
import './AppTopBar.scss';
import CircularProgress from "./CircularProgress";
import StepsHeader from "./StepsHeader";
import CloseIconBig from "../icons/CloseIconBig";
import { _t } from '../utils/Lang';




const AppTopBar = observer(() => {
    const windowSize = useWindowSize();
    const isMattressActive = store.steps.get('mattress')?.active;

    if (windowSize.width < 992) {

        if (store.isFabricCategoryOpen) {
            return (

                <div className="AppTopBar w-100" onWheel={e => e.stopPropagation()}>

                    <div className="d-flex a-center">
                        <button type='button' onClick={() => {
                            store.closeSwatches();
                            store.closeSwatchesCategory();
                            store.closeFabricCategory();
                        }} className="AppTopBar__back">
                            <BackIconBig className={'ms-1 me-2'} />
                            {_t('back_to_fabric')}
                        </button>
                    </div>
                </div>
            )
        }
        if (store.isSwatchesCategoryOpen) {
            return (

                <div className="AppTopBar w-100" onWheel={e => e.stopPropagation()}>

                    <div className="d-flex a-center">
                        <button type='button' onClick={() => {
                            store.closeSwatchesCategory();
                        }} className="AppTopBar__back">
                            <BackIconBig className={'ms-1 me-2'} />
                            {_t('back_to_fabric')}
                        </button>
                    </div>
                </div>
            )
        }
        if (store.isSwatchesOpen) {
            return (

                <div className="AppTopBar w-100" onWheel={e => e.stopPropagation()}>

                    <div className="d-flex a-center">
                        <button type='button' onClick={() => {
                            store.closeSwatches();
                            store.closeSwatchesCategory();
                            store.closeFabricCategory();
                        }} className="AppTopBar__back">
                            <BackIconBig className={'ms-1 me-2'} />
                            {_t('close_and_return')}
                        </button>
                    </div>
                </div>
            )
        }

        return (
            <div className="AppTopBar w-100" onWheel={e => e.stopPropagation()}>
                <div className="d-flex a-center">
                    <CircularProgress value={isMattressActive ? 2 : 1} max={2} size={32} strokeWidth={2} />
                    <div className="grow">
                        <b className="d-block">{_t('configuration_title')}</b>
                        <a onClick={() => {
                            store.openSummaryPopup();
                        }}>{_t('view_selected')}</a>


                    </div>
                    <button
                        className="ml-auto"
                        type='button' onClick={() => {
                            store.openOnExit();
                        }}
                    >
                        <CloseIconBig className={'ms-1 AppTopBar__close'} />
                    </button>
                </div>
            </div>
        );
    }

    return <StepsHeader />
});
AppTopBar.displayName = 'AppTopBar';
export default AppTopBar;